__turbopack_context__.v({
  "body": "ParagraphHeroProduct-module__-GDX2G__body",
  "btn": "ParagraphHeroProduct-module__-GDX2G__btn",
  "btnBadge": "ParagraphHeroProduct-module__-GDX2G__btnBadge",
  "btnMuted": "ParagraphHeroProduct-module__-GDX2G__btnMuted",
  "btnOutline": "ParagraphHeroProduct-module__-GDX2G__btnOutline",
  "btnPrimary": "ParagraphHeroProduct-module__-GDX2G__btnPrimary",
  "btnWrap": "ParagraphHeroProduct-module__-GDX2G__btnWrap",
  "buttons": "ParagraphHeroProduct-module__-GDX2G__buttons",
  "description": "ParagraphHeroProduct-module__-GDX2G__description",
  "eyebrow": "ParagraphHeroProduct-module__-GDX2G__eyebrow",
  "footnote": "ParagraphHeroProduct-module__-GDX2G__footnote",
  "grid": "ParagraphHeroProduct-module__-GDX2G__grid",
  "media": "ParagraphHeroProduct-module__-GDX2G__media",
  "mediaWrap": "ParagraphHeroProduct-module__-GDX2G__mediaWrap",
  "section": "ParagraphHeroProduct-module__-GDX2G__section",
  "title": "ParagraphHeroProduct-module__-GDX2G__title",
  "tooltip": "ParagraphHeroProduct-module__-GDX2G__tooltip",
  "tooltipCta": "ParagraphHeroProduct-module__-GDX2G__tooltipCta",
  "tooltipDesc": "ParagraphHeroProduct-module__-GDX2G__tooltipDesc",
});
